class NavDrawer extends HTMLElement {
  constructor() {
    super();

    this.$drawer = document.querySelector('.js-nav-drawer');

    this.$open = document.querySelector('.js-nav-toggle');
    this.$open.addEventListener('click', this.open.bind(this));
    
    this.$close = document.querySelector('.js-nav-drawer-close');
    this.$close.addEventListener('click', this.close.bind(this));

    this.$subMenu = document.querySelectorAll('.js-sub-menu');

    const self = this;
    document.querySelectorAll('.js-submenu-toggle').forEach($elm => {
      $elm.addEventListener('click', function(e){
        self.subMenuToggle($elm);
        e.preventDefault();
      });
    });
  }

  open() {
    this.$drawer.classList.add('js-nav-drawer-open');
    document.documentElement.classList.add('no-scroll');
    document.body.classList.add('no-scroll');
  }

  close() {
    this.$drawer.classList.remove('js-nav-drawer-open');
    document.documentElement.classList.remove('no-scroll');
    document.body.classList.remove('no-scroll');
  }

  subMenuToggle($elm) {
    const $wrap = $elm.closest('li').querySelector('.menu-drawer__sub-menu');

    if( !$wrap )
      return false;
    $elm.classList.toggle('js-is-active');
    const $list = $wrap.querySelector('ul');
    const height = $wrap.offsetHeight == 0 ? $list.offsetHeight : 0;
    $wrap.style.height = `${height}px`; 
  }
}

customElements.define('nav-drawer', NavDrawer);